import React from 'react'
import classnames from 'classnames'
import Resx from '@/components/Resx'

export function Infos (props) {
  return (<div {...props} className={classnames('infos', props.className)}>{props.children}</div>)
}

export function InfoRow ({ form, className, children, ...props }) {
  let classN = form ? 'info__row info__row--form' : 'info__row'
  return (<div {...props} className={classnames(classN, className)}>{children}</div>)
}

export function InfoLabel ({ size, top, children, ...props }) {
  let isSmall = size === 'sm' || size === 'small'
  let isLarge = size === 'lg' || size === 'large'
  let isXL = size === 'xl' || size === 'extraLarge'

  return (<div {...props} className={classnames('info-label', { 'info-label--sm': isSmall, 'info-label--lg': isLarge, 'info-label--xl': isXL, 'info-label--top': top }, props.className)}>{children}</div>)
}

export function InfoContent ({ className, children, ...props }) {
  return (<div {...props} className={classnames('info-content', className)}>{children}</div>)
}

export function InfoRowWithLabel ({ children, label }) {
  return (
    <InfoRow>
      <InfoLabel><Resx name={label} /></InfoLabel>
      <InfoContent>{children}</InfoContent>
    </InfoRow>
  )
}



// WEBPACK FOOTER //
// ./src/components/InfoRow.js